import axios from 'axios';
const API_URL = "https://ims.holdthechild.net/api/milestones";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
};

/**
 * Creates a new milestone for a specific project.
 * @param {string} projectId - The ID of the project.
 * @param {object} milestoneData - The data for the new milestone (title, description, dueDate, etc.).
 * @returns {Promise<object>} The created milestone object.
 */
export const createMilestone = async (projectId, milestoneData) => {
    try {
        const response = await axios.post(
            `${API_URL}/projects/${projectId}/milestones`,
            milestoneData,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to create milestone.';
        throw new Error(errorMessage);
    }
};

/**
 * Fetches all milestones for a specific project.
 * @param {string} projectId - The ID of the project.
 * @returns {Promise<Array<object>>} An array of milestone objects.
 */
export const getMilestonesByProject = async (projectId) => {
    try {
        const response = await axios.get(
            `${API_URL}/projects/${projectId}/milestones`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to fetch milestones.';
        throw new Error(errorMessage);
    }
};

/**
 * Updates an existing milestone by its ID.
 * @param {string} milestoneId - The ID of the milestone to update.
 * @param {object} updatedData - The new data for the milestone.
 * @returns {Promise<object>} The updated milestone object.
 */
export const updateMilestone = async (milestoneId, updatedData) => {
    try {
        const response = await axios.put(
            `${API_URL}/milestones/${milestoneId}`,
            updatedData,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to update milestone.';
        throw new Error(errorMessage);
    }
};

/**
 * Deletes a milestone by its ID.
 * @param {string} milestoneId - The ID of the milestone to delete.
 * @returns {Promise<object>} A success message object.
 */
export const deleteMilestone = async (milestoneId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/milestones/${milestoneId}`,
            getAuthHeaders()
        );
        return response.data;
    } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to delete milestone.';
        throw new Error(errorMessage);
    }
};